import * as React from "react"
import { Link } from "react-router-dom"
import { Button, Card, CardContent, CardHeader, Separator, Badge, ThemeToggle } from "@/shared/ui"
import { ArrowRight, ShieldCheck, LineChart, Layers3, Zap } from "lucide-react"
import { LandingHeader, HeroSection6, Logo } from "@/modules/landing/components/HeroSection6"
import PlansHomeSection from "@/modules/landing/components/PlansHomeSection"
import RewardsHomeSection from "@/modules/rewards/components/RewardsHomeSection"
import SectionWithMockup from "@/components/blocks/section-with-mockup"
import CoinsLogoCarousel from "@/modules/landing/components/CoinsLogoCarousel"
import MonitoringGlowingSection from "@/modules/landing/components/MonitoringGlowingSection"
import TestimonialsMarqueeHome from "@/modules/testimonials/components/TestimonialsMarqueeHome"
import { FaqHomeSection } from "@/modules/faq"
import imgDiferenciais from "@/images/img-diferenciais-front.png"
import HomeDisclaimerSection from "@/modules/landing/components/HomeDisclaimerSection"
import { WhatsappFloatingButton } from "@/modules/landing/components/WhatsappFloatingButton"
import LandingFooter from "@/modules/landing/components/LandingFooter"
import { useLandingSectionOnLoad } from "@/modules/landing/hooks/useLandingSectionNavigation"

export default function Home() {
  useLandingSectionOnLoad()

  return (
    <div className="min-h-screen">
      <LandingHeader />
      <main className="w-full px-0 pb-24">
        <HeroSection6 />
        <SectionWithMockup
          id="diferenciais"
          title={<>{"Metodologia e Transpar\u00eancia"}</>}
          description={
            <>
              {"O Cripto Alert monitora o mercado em tempo real e identifica cen\u00e1rios t\u00e9cnicos a partir de indicadores e conflu\u00eancias. Cada alerta vem com contexto e crit\u00e9rios de invalida\u00e7\u00e3o, para apoiar sua an\u00e1lise e gest\u00e3o de risco."}
              <span className="mt-2 block text-xs text-foreground/60 italic">
                {"Resultados variam; n\u00e3o h\u00e1 garantias."}
              </span>
            </>
          }
          primaryImageSrc={imgDiferenciais as unknown as string}
          secondaryImageSrc="https://www.fey.com/marketing/_next/static/media/newsletter-desktop-1_4x.9cc114e6.png"
          showBottomLine={false}
        />
        <MonitoringGlowingSection />
        <CoinsLogoCarousel />
        <PlansHomeSection />
        <RewardsHomeSection />
        <TestimonialsMarqueeHome />
        <FaqHomeSection />
        <HomeDisclaimerSection />
      </main>
      <LandingFooter />
      <WhatsappFloatingButton />
    </div>
  )
}
